/* Terralite: add-to-cart on product cards (snippets/tl-product-card.liquid with show_add). Posts to /cart/add.js,
   then hands the new cart to Pipeline (theme:cart:change) and fires Pipeline's after-add event (on the product popdown wrapper, or on the document when a page has none, e.g. the homepage) so
   tl-cart-open-on-add opens the drawer with the Cart setting on, or the "added" notice shows. Without JavaScript the form posts to /cart/add as usual. */
(function () {
  'use strict';
  if (window.tlCartAdd) return;
  window.tlCartAdd = true;
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-tl-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-tl-add-btn]');
    if (btn && btn.classList.contains('is-busy')) return;
    if (btn) btn.classList.add('is-busy');
    var body = new URLSearchParams(new FormData(form)).toString();
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' }, body: body, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (line) {
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
          var pd = document.querySelector('[data-product-add-popdown-wrapper]') || document;
          pd.dispatchEvent(new CustomEvent('theme:cart:popdown', { detail: { variant: line }, bubbles: true }));
          if (btn) { btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 2200); }
        });
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.classList.remove('is-busy'); });
  });
})();
